import { useParams, useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useState } from "react";

const plans = [
  { id: 1, name: "Gold Plan", price: "3500", features: ["For 6 Months","200 profile searches","Unlimited messaging","Access to public profiles"] },
  { id: 2, name: "Platinum Plan", price: "4500", features: ["For one year","500 profile searches","Unlimited messaging","Profile verification"] },
  { id: 3, name: "Kohinoor Plan", price: "5000", features: ["Unlimited access","Unlimited searches","Unlimited messaging","Priority support","Access to all profiles"] },
];

const YOUR_UPI_ID = "nishagiramkar94@okaxis";
const YOUR_NAME = "ShubhJiwan";

const PaymentPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const plan = plans.find((p) => p.id === parseInt(id));
  const [paymentDone, setPaymentDone] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [transactionId, setTransactionId] = useState("");

  if (!plan) return <p className="text-center mt-10 text-red-500 text-xl">Plan not found</p>;

  const upiLink = `upi://pay?pa=${YOUR_UPI_ID}&pn=${encodeURIComponent(YOUR_NAME)}&am=${plan.price}&cu=INR`;

const handlePaymentSubmit = async () => {
  const userId = localStorage.getItem("userId");
  if (!userId) {
    alert("User is not logged in.");
    return;
  }

  if (transactionId.trim() === "" || paymentMethod === "") {
    alert("Please enter a transaction ID and select a payment method.");
    return;
  }

    // Validate Transaction ID (12 characters)
  if (transactionId.length !== 12) {
    alert("Transaction ID must be exactly 12 digits long.");
    return;
  }

  try {
    const response = await fetch("https://shubhjiwan.co.in/ShubhJiwan_backend11/save_transaction.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        userId: parseInt(userId),
        transactionId: transactionId,
        paymentMethod: paymentMethod,
        planId: plan.id
      }),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "Error saving transaction.");
    }

    alert(result.message || "Transaction saved successfully.");
    navigate("/");
  } catch (error) {
    alert("Failed to save transaction. " + error.message);
    console.error("Error:", error);
  }
};


  return (
    <>
      <Navbar />
      <div className="pt-20 pb-20 min-h-screen bg-gray-50 flex items-center justify-center p-6">
        <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md text-center">
          <h2 className="text-3xl font-extrabold text-pink-600 mb-2">{plan.name}</h2>
          <p className="text-xl font-semibold text-gray-700 mb-4">₹ {plan.price}</p>

          <div className="flex justify-center mb-4">
            <QRCodeCanvas value={upiLink} size={200} />
          </div>

          <p className="text-sm text-gray-600 mb-6">
            Scan this QR with any UPI app to pay ₹{plan.price} to <strong>{YOUR_NAME}</strong>
          </p>

           <ul className="text-gray-700 text-left list-disc list-inside mb-6 space-y-1">
          {plan.features.map((feature, idx) => (
            <li key={idx}>{feature}</li>
          ))}
        </ul>

          {!paymentDone ? (
            <button
              onClick={() => setPaymentDone(true)}
              className="mt-6 w-full bg-green-600 text-white py-3 rounded-full hover:bg-green-700 transition"
            >
              I Have Completed the Payment
            </button>
          ) : (
            <div>
              <div className="mt-4">
                <select
                  className="w-full p-2 mb-4 border rounded"
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                >
                  <option value="">Select Payment Method</option>
                  <option value="Google Pay">Google Pay</option>
                  <option value="PhonePe">PhonePe</option>
                  <option value="Paytm">Paytm</option>
                </select>
                <input
                  type="text"
                  placeholder="Enter Transaction ID / UTR No. (12 digits)"
                  value={transactionId}
                  onChange={(e) => setTransactionId(e.target.value.slice(0, 12))}
                  className="w-full p-2 border rounded mb-4"
                  maxLength="12"
                />

                <button
                  onClick={handlePaymentSubmit}
                  className="mt-6 w-full bg-green-600 text-white py-3 rounded-full hover:bg-green-700 transition"
                >
                  Submit Transaction
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PaymentPage;
